import React from "react";
import "../styles/home.css";
import { useNavigate } from "react-router-dom";
import InfoSection from "../components/InfoSection"; // ✅ import new section
import PackageBanner from "../components/PackageBanner"; // ✅ Import banner

export default function Home() {
  const navigate = useNavigate();

  const handleOpenForm = () => {
    navigate("/book");
  };

  return (
    <>
      {/* ✅ Hero Section */}
      <section className="home">
        <img
          src={process.env.PUBLIC_URL + "/assets/hero.webp"}
          alt="Lak Derana Cabs Hero"
          className="home-bg"
          loading="lazy"
        />

        <div className="home-content">
          <h1>Start Your Journey</h1>
          <button onClick={handleOpenForm}>Book Now</button>
        </div>
      </section>
      <InfoSection />
      {/* ✅ Auto-Swiping Package Banner */}
      <PackageBanner />
    </>
  );
}
